
export const swalMssgs = {
    DELETE_SUCCESS: "Se ha eliminado correctamente",
    UPDATE_SUCCES: "Se ha actualizado correctamente",
    NEW_SUCCES:"Se ha añadido correctamente"
}
